function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import StoreFilters from "./storeFilters.class";
import { Constants as CONSTANTS } from "./constants.class";
import Modal from "@mozaic-ds/freemarker/js/modules/_modal";
var Sort = /*#__PURE__*/function (_StoreFilters) {
  function Sort(config) {
    var _this;
    _classCallCheck(this, Sort);
    _this = _callSuper(this, Sort, [config]);
    try {
      if (config.event === undefined || config.event === null) throw new Error("CLass Sort need event in parameters");
      _this.sortingElement = null;
      _this.initEvent();
      _this.initModal();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Error class Sort", err);
    }
    return _this;
  }

  /**
   * init event of select of sorting
   */
  _inherits(Sort, _StoreFilters);
  return _createClass(Sort, [{
    key: "initEvent",
    value: function initEvent() {
      this.sortingElement = document.querySelector(".".concat(CONSTANTS.SORT.SELECTOR));
      this.sortingElement.addEventListener("change", _sorting.bind(this));
    }
  }, {
    key: "initModal",
    value: function initModal() {
      if (document.querySelector(".".concat(CONSTANTS.SORT.INFORMATION_MODAL.CONTENT))) {
        var modal = new Modal({
          classContent: CONSTANTS.SORT.INFORMATION_MODAL.CONTENT
        });
        var openModalButton = document.querySelector(".".concat(CONSTANTS.SORT.INFORMATION_MODAL.OPEN_BUTTON));
        var closeModalButton = document.querySelector(".".concat(CONSTANTS.SORT.INFORMATION_MODAL.CLOSE_BUTTON));
        openModalButton.addEventListener("click", function () {
          modal.open();
        });
        closeModalButton.addEventListener("click", function () {
          modal.close();
        });
      }
    }
  }]);
}(StoreFilters);
export default Sort;
function _sorting(evt) {
  this.dispatch({
    action: "sort",
    filters: {
      sorting: evt.target.value
    }
  });
}